//Action Types
export const SET_PAGE_TITLE = "SET_PAGE_TITLE";

//Action Creators
export const setPageTitle = value => ({
  type: SET_PAGE_TITLE,
  value
});
